import { render } from "./EventCard.vue?vue&type=template&id=46b82aea&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=46b82aea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46b82aea"]])

export default __exports__